import { useQuery } from '@tanstack/react-query';
import { NewsFilters } from '@toggle/toggle';

import { fetchNewsFilters } from '~/services/news/news-service';

const QUERY_NEWS_FILTERS = 'QUERY_NEWS_FILTERS';

export const useGetFilters = () => {
  return useQuery<NewsFilters>({
    queryKey: [QUERY_NEWS_FILTERS],
    queryFn: () => fetchNewsFilters(),
  });
};
